export default function () {
  return [
    {
      title: '姓名',
      [$field]: 'memberUserName'
    },
    {
      title: '工号',
      [$field]: 'employeeNumber'
    },
    {
      'title': '操作',
      'width': 230,
      [$field]: 'operate',
      'isOperate': true
    }
  ]
}
